import { render, staticRenderFns } from "./HistoricalProcedingFilter.vue?vue&type=template&id=51007131&scoped=true&"
import script from "./HistoricalProcedingFilter.vue?vue&type=script&lang=js&"
export * from "./HistoricalProcedingFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51007131",
  null
  
)

export default component.exports